import { render, staticRenderFns } from "./Tents.vue?vue&type=template&id=74e9d1b2&"
import script from "./Tents.vue?vue&type=script&lang=js&"
export * from "./Tents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports